import { createBitkitToast } from '@bitrise/bitkit-v2';
import { useEffect } from 'react';

import { GlobalProps, PopupAlert } from '@/models/GlobalProps';

const shownFlashes = new WeakSet<NonNullable<GlobalProps['flash']>>();

export default function useFlashToast(flash: GlobalProps['flash']): void {
  useEffect(() => {
    if (!flash || shownFlashes.has(flash)) {
      return;
    }
    shownFlashes.add(flash);

    const successToast = (message: string | PopupAlert) =>
      createBitkitToast({
        messageText: typeof message === 'string' ? message : message.description,
        titleText: typeof message === 'string' ? 'Success' : message.title,
        variant: 'success',
      });
    const errorToast = (message: string | PopupAlert) =>
      createBitkitToast({
        messageText: typeof message === 'string' ? message : message.description,
        titleText: typeof message === 'string' ? 'Error' : message.title,
        variant: 'critical',
      });

    if (flash.notice) {
      successToast(flash.notice);
    }
    if (flash.popupAlertSuccess) {
      successToast(flash.popupAlertSuccess);
    }
    if (flash.alert) {
      errorToast(flash.alert);
    }
    if (flash.popupAlertError) {
      errorToast(flash.popupAlertError);
    }
  }, [flash]);
}
